<div class="" fxLayout="column" fxLayoutAlign="center center">
  <h1 mat-dialog-title >{{'LANDINFOCUS.STEP_COLAB.STEP_2.TITULO_MODAL_DEMOGRA' | translate}}</h1>  
</div>
<mat-dialog-content class="mat-typography">
<mat-selection-list #shoes [(ngModel)]="filtrosElegidos">
  <ng-container *ngFor="let categoria of categorias">
    <mat-list-option *ngIf="!categoria.elegido" [value]="categoria.key">
    {{'LANDINFOCUS.STEP_COLAB.STEP_2.FORMULARIO.'+categoria.key | translate}}
    </mat-list-option>
  </ng-container>
</mat-selection-list>
</mat-dialog-content >
<div mat-dialog-actions>
  <button mat-button  class="primary rndBt" (click)="salir()">{{'LANDINFOCUS.STEP_COLAB.STEP_2.BTN_ACEPTAR' | translate}}</button>
</div>
